import { useState } from "react";
import { MiList } from "@miplatform/components";
import { IDocumentListItemResponse, IWorkOrder } from "@miplatform/types";
import { useDocumentsViewModel } from "@miplatform/view-models";
import { DocumentCard, EmptyMessageView } from "@mibuildweb/components";
import { Box } from "@mui/material";

export const WorkOrderDrawerDocumentsTab = ({
  workOrder,
}: {
  workOrder: IWorkOrder;
}) => {
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentListItemResponse | null>(null);
  const { documents = [] } = workOrder;

  const { printFile, downloadFile, loading } = useDocumentsViewModel();

  if (documents.length === 0) {
    return (
      <EmptyMessageView
        title="No Documents"
        subtitle="No documents have been added to this work order yet"
      />
    );
  }

  return (
    <Box>
      <MiList
        viewType="card"
        data={documents}
        CardComponent={DocumentCard}
        cardProps={{
          onPrint: printFile,
          onDownload: downloadFile,
          onSelect: setSelectedDocument,
          selectedDoc: selectedDocument,
        }}
        loading={loading}
        hideListPagination
      />
    </Box>
  );
};
